var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path2, _path3, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 106,
    viewBox: "0 0 113 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 4.5L82.5 95M30 95L82.5 4.5M3.5 49.5H108",
    stroke: "#005B7F",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 5,
    r: 5,
    fill: "#005B7F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 5,
    r: 5,
    fill: "#005B7F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 50,
    r: 5,
    fill: "#005B7F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 50,
    r: 5,
    fill: "#005B7F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 95,
    r: 5,
    fill: "#005B7F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 95,
    r: 5,
    fill: "#005B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4164 37.3273L57.5 25.1547L78.5836 37.3273V61.6726L57.5 73.8453L36.4164 61.6726V37.3273Z",
    fill: "white",
    stroke: "#005B7F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 51L42.5 47.5V41.5L55.5 33.5L69 40.5M54 59V50L62 45M41.5 58L55.5 66.5L71.5 57V47.5L61 53.5",
    stroke: "#FF8646",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 39.5,
    r: 3.5,
    fill: "#FF8646"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 50.5,
    r: 3.5,
    fill: "#FF8646"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 45.5,
    r: 3.5,
    fill: "#FF8646"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 58.5,
    r: 3.5,
    fill: "#FF8646"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 53.5,
    r: 3.5,
    fill: "#FF8646"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 58.5,
    r: 3.5,
    fill: "#FF8646"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 95,
    r: 10,
    stroke: "#FF8646",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderImg);
export default __webpack_public_path__ + "static/media/orderIMG.ebb1d896a12edaf379082480a235d448.svg";
export { ForwardRef as ReactComponent };